import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import '../CSS/Vouchers.css';
import axios from 'axios';
import voucher from '../Images/GiftVoucher500500.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faCheck, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { getVoucherDiscountStatus } from '../utils/getVoucherDiscountStatus';
import { validateManualDiscountCode } from '../utils/validateManualDiscountCode';
import { validateVoucherCode } from '../utils/validateVoucherCode';

const VouchersEN = () => {
    const [searchParams] = useSearchParams();

    const [step, setStep] = useState(1);
    const [confirmation, setConfirmationMessage] = useState(false);

    const [name, setName] = useState('');
    const [emailCompra, setEmailCompra] = useState('');
    const [emailPrenda, setEmailPrenda] = useState('');
    const [nomePrenda, setNomePrenda] = useState('');
    const [contactNum, setContactNum] = useState('');
    const [discountCode, setDiscountCode] = useState('');
    const [discountValidating, setDiscountValidating] = useState(false);
    const [discountValidation, setDiscountValidation] = useState(null);
    const [showMedievalDiscount, setShowMedievalDiscount] = useState(false);
    const [codeURL, setCodeURL] = useState('');
    const [festaHistoriaValid, setFestaHistoriaValid] = useState(false);
    const [festaHistoriaChecking, setFestaHistoriaChecking] = useState(false);

    useEffect(() => {
        const fromUrl = (searchParams.get('code') || searchParams.get('Code') || '').trim();
        setCodeURL(fromUrl);
    }, [searchParams]);

    useEffect(() => {
        let cancelled = false;
        getVoucherDiscountStatus()
            .then((isOn) => {
                if (!cancelled) setShowMedievalDiscount(isOn);
            })
            .catch(() => {
                if (!cancelled) setShowMedievalDiscount(false);
            });
        return () => {
            cancelled = true;
        };
    }, []);

    useEffect(() => {
        const isFestaHistoria = codeURL.trim().toLowerCase() === 'festahistoria';
        if (!isFestaHistoria) {
            setFestaHistoriaValid(false);
            setFestaHistoriaChecking(false);
            return;
        }

        let cancelled = false;
        setFestaHistoriaChecking(true);
        setFestaHistoriaValid(false);
        validateVoucherCode(codeURL)
            .then((isValid) => {
                if (!cancelled) setFestaHistoriaValid(isValid === true);
            })
            .catch(() => {
                if (!cancelled) setFestaHistoriaValid(false);
            })
            .finally(() => {
                if (!cancelled) setFestaHistoriaChecking(false);
            });

        return () => {
            cancelled = true;
        };
    }, [codeURL]);

    const Step = () => {
        return (
            <div className='stepsDiv'>
                <div className='step'>
                    <div className='stepCircle'>
                        <p className={`circle ${step === 1 || step === 2 || step === 3  ? 'circle-active' : 'circle'}`}>1</p>
                    </div>

                    <div className='stepText'>
                        <p>Voucher</p> 
                    </div>
                </div>

                <div className={`stepConnector ${step >= 2 ? 'stepConnector-active' : ''}`} aria-hidden="true" />

                <div className='step'>
                    <div className='stepCircle'>
                        <p className={`circle ${step === 2 || step === 3 ? 'circle-active' : 'circle'}`}>2</p>
                    </div>

                    <div className='stepText'>
                        <p>Information</p> 
                    </div>
                </div>

                <div className={`stepConnector ${step >= 3 ? 'stepConnector-active' : ''}`} aria-hidden="true" />

                <div className='step'>
                    <div className='stepCircle'>
                        <p className={`circle ${step === 3 ? 'circle-active' : 'circle'}`}>3</p>
                    </div>

                    <div className='stepText'>
                        <p>Check-out</p>
                    </div>
                </div>
            </div>
        );
    };

    const goBackButton = () => {
        setStep(step - 1);
    };

    const goForwardButton = () => {
        setStep(step+1);
    };

    const go3Button = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailRegex.test(emailCompra) === true && name !== '') {
            setStep(step + 1);
        }
    };

    const proceedPayment = () => {
        handleSubmit();
        setConfirmationMessage(true);
    };

    const handleName = (event) => {
        setName(event.target.value);
    };

    const handleNamePrenda = (event) => {
        setNomePrenda(event.target.value);
    };

    const handleEmails = (event) => {
        setEmailCompra(event.target.value);
    };

    const handleContactNum = (event) => {
        setContactNum(event.target.value);
    };

    const handleEmailPrenda = (event) => {
        setEmailPrenda(event.target.value);
    };

    const handleDiscountCodeChange = (event) => {
        setDiscountCode(event.target.value);
        setDiscountValidation(null);
    };

    const handleValidateDiscount = async () => {
        const code = discountCode.trim();
        if (!code) {
            setDiscountValidation('invalid');
            return;
        }

        setDiscountValidating(true);
        setDiscountValidation(null);
        try {
            const isValid = await validateManualDiscountCode(code);
            setDiscountValidation(isValid ? 'valid' : 'invalid');
        } catch (error) {
            setDiscountValidation('error');
        } finally {
            setDiscountValidating(false);
        }
    };

    const isFestaHistoriaCode = codeURL.trim().toLowerCase() === 'festahistoria';
    const isFestaHistoriaApplied = isFestaHistoriaCode && festaHistoriaValid;

    const handleSubmit = async () => {

        const Voucher = {
            Name: name,
            Email: emailCompra,
            GiftEmail: emailPrenda,
            GiftName: nomePrenda,
            Code: isFestaHistoriaApplied
                ? 'FestaHistoria'
                : (discountValidation === 'valid' ? discountCode.trim() : ''),
            CodeURL: codeURL,
            Used: false,
            HasRepetition: false,
            ExpirationDate: null,
            DiscountId: null,
            Contact: contactNum
        };
        try {
            await axios.post('https://personal-d4yby5if.outsystemscloud.com/Booking_API/rest/Vouchers/v3/Create', Voucher);
        } catch (error) {
            
        }
        
    };
      
    return (
        <div className="er-pageShell">
            <Step/>

            {confirmation ? (
                <div className='mainDiv er-container'>
                    <p className='textSimple'>Thank you! Check your email — your voucher will be sent to you (and to the gift recipient, if you added their email).</p>
                </div>
            ) : (
                <div className='mainDiv er-container'>                    
                    {step === 1 ? (
                        <div>
                            <div className='divCentrado'>
                                <div className='divVoucherLeft'>
                                    <img src={voucher} alt="Background" className='imageCard'/>
                                </div>

                                <div className='divVoucherRight'>
                                <p>Not sure what to gift that special someone? Looking for a unique present?</p>

                                <p>We have the perfect solution for you! Gift an experience at Escape Room Bragança.</p>

                                <p>Get our <span style={{ color: '#F4B366' }}>voucher</span> now and surprise them!</p>

                                <p>Each voucher costs 40€ and is valid for an experience for up to 4 people.</p>

                                </div>
                            </div>                            

                            <div className='buttonDiv'>
                                <button className='goButtonWeb' onClick={goForwardButton}>CONTINUE <FontAwesomeIcon icon={faArrowRight} className="hiddeniconBtn"/></button>
                            </div>
                        </div>                    
                    ) : (
                        step === 2 ? (
                            <div>

                                <div>
                                    <p className='textSimple'>Buying a voucher is easy! Tell us your name, email and contact number so we can send it to you.</p>
                                    <p className='textSimple'>If it’s a gift, you can add the recipient’s name and email and the voucher will go to them.</p>

                                    <br/>
                                    
                                    <label htmlFor="name" className='textSimpleYellow'>From (name):</label>
                                    <label className="errorStar">*</label>
                                            <input
                                                className='inputLine'
                                                type="text"
                                                id="name"
                                                value={name}
                                                onChange={handleName}
                                                required
                                            />

                                    <br/>
                                    <br/>

                                    <label htmlFor="emailCompra" className="textSimpleYellow">From (email):</label>
                                    <label className="errorStar">*</label>
                                    <input
                                        className="inputLine"
                                        type="text"
                                        id="emailCompra"
                                        value={emailCompra}
                                        onChange={handleEmails}
                                        required
                                    />

                                    <br/>
                                    <br/>

                                    <label htmlFor="contactNum" className="textSimpleYellow">Contact:</label>
                                    <label className="errorStar">*</label>
                                    <input
                                        className="inputLine"
                                        type="tel"
                                        id="contactNum"
                                        value={contactNum}
                                        onChange={handleContactNum}
                                        required
                                    />

                                    <br/>
                                    <br/>

                                    <label htmlFor="nomePrenda" className="textSimpleYellow">To (name) (optional):</label>
                                    <input
                                        className="inputLine"
                                        type="text"
                                        id="nomePrenda"
                                        value={nomePrenda}
                                        onChange={handleNamePrenda}
                                    />

                                    <br/>
                                    <br/>

                                    <label htmlFor="emailPrenda" className="textSimpleYellow">To (email) (optional):</label>
                                    <input
                                        className="inputLine"
                                        type="text"
                                        id="emailPrenda"
                                        value={emailPrenda}
                                        onChange={handleEmailPrenda}
                                    />
                                </div>

                                <br/>

                                <div className='buttonDiv'>
                                    <button className='gobackButton' onClick={goBackButton}><FontAwesomeIcon icon={faAngleLeft}/> BACK</button>
                                    <button className='goButtonWeb' onClick={go3Button}>CHECK-OUT <FontAwesomeIcon icon={faArrowRight} className="hiddeniconBtn"/></button>
                                </div>
                            </div>  
                        ) : (
                            <div>
                                <p className='textSimple'>Once you finish, an email will be sent with more information on how to proceed with payment.</p>
                                <p className='textSimple'>If you have any questions, please contact us through the available communication channels.</p>

                                {showMedievalDiscount || isFestaHistoriaApplied || (isFestaHistoriaCode && festaHistoriaChecking) ? (
                                    <div className="er-medievalDiscount" aria-label="Medieval Days discount">
                                        <div className="er-medievalFlag er-medievalFlag--left" aria-hidden="true">
                                            <span className="er-medievalFlagPole" />
                                            <span className="er-medievalFlagCloth" />
                                        </div>

                                        <div className="er-medievalDiscountInner">
                                            <p className="er-medievalDiscountTitle">Medieval Days</p>
                                            {isFestaHistoriaApplied ? (
                                                <p className="er-medievalDiscountApplied">The medieval code is already applied!</p>
                                            ) : isFestaHistoriaCode && festaHistoriaChecking ? (
                                                <p className="er-medievalDiscountHint">Validating the medieval code…</p>
                                            ) : (
                                                <>
                                                    <label htmlFor="discountCode" className="textSimpleYellow">I have a discount code:</label>
                                                    <div className="voucherCodeRow er-voucherDiscountRow">
                                                        <input
                                                            className="inputLine voucherCodeInput"
                                                            type="text"
                                                            id="discountCode"
                                                            value={discountCode}
                                                            onChange={handleDiscountCodeChange}
                                                            placeholder="Enter your code"
                                                        />
                                                        <button
                                                            type="button"
                                                            className="voucherValidateButton"
                                                            onClick={handleValidateDiscount}
                                                            disabled={discountValidating || !discountCode.trim()}
                                                        >
                                                            {discountValidating ? 'Validating...' : 'Validate'}
                                                        </button>
                                                    </div>
                                                    {discountValidation === 'valid' ? (
                                                        <p className="voucherCodeMessage voucherCodeMessage--valid">Valid code.</p>
                                                    ) : null}
                                                    {discountValidation === 'invalid' ? (
                                                        <p className="voucherCodeMessage voucherCodeMessage--invalid">Invalid or expired code.</p>
                                                    ) : null}
                                                    {discountValidation === 'error' ? (
                                                        <p className="voucherCodeMessage voucherCodeMessage--invalid">Could not validate the code. Please try again.</p>
                                                    ) : null}
                                                </>
                                            )}
                                        </div>

                                        <div className="er-medievalFlag er-medievalFlag--right" aria-hidden="true">
                                            <span className="er-medievalFlagPole" />
                                            <span className="er-medievalFlagCloth" />
                                        </div>
                                    </div>
                                ) : null}

                                <div className='buttonDiv'>
                                    <button className='gobackButton' onClick={goBackButton}><FontAwesomeIcon icon={faAngleLeft}/> BACK</button>
                                    <button className='goButtonWeb' onClick={proceedPayment}>FINISH <FontAwesomeIcon icon={faCheck} className="hiddeniconBtn"/></button>
                                </div>
                            </div>  
                        )
                    )}
                </div>
            )}          

        </div>
    );

};

export default VouchersEN;
